<div class="page-not-found">
    <div id="alert" class="alert">
        <div class="alert__icon icon-info-outline"></div>
        <div class="alert__message">404 - Page Not Found</div>
    </div>
</div>